/**
 * 사이드바 네비게이션 섹션 컴포넌트
 */ import React from 'react';
import { MAIN_LAYOUT_TEST_IDS } from '@edusense/shared-constants';
export const NavigationSection = ({ navigationItems, activeMenu, onMenuClick, isTabletView, isMobileSidebar, isIconOnlyMode })=>{
    const handleMenuItemClick = (itemId)=>{
        if (onMenuClick) {
            onMenuClick(itemId);
        }
    };
    // 네비게이션 아이템 ID를 testid로 매핑하는 함수
    const getNavTestId = (itemId)=>{
        switch(itemId){
            case 'home':
                return MAIN_LAYOUT_TEST_IDS.NAV_FEED;
            case 'courses':
                return MAIN_LAYOUT_TEST_IDS.NAV_LEARN;
            case 'about':
                return MAIN_LAYOUT_TEST_IDS.NAV_DISCOVER;
            case 'profile':
                return MAIN_LAYOUT_TEST_IDS.NAV_PROFILE;
            case 'settings':
                return MAIN_LAYOUT_TEST_IDS.NAV_SETTINGS;
            default:
                return `nav-${itemId}`;
        }
    };
    const isCompact = typeof isIconOnlyMode === 'boolean' ? isIconOnlyMode : isTabletView;
    return /*#__PURE__*/ React.createElement("nav", {
        style: {
            width: '100%',
            display: 'flex',
            flexDirection: 'column',
            alignItems: isMobileSidebar ? 'flex-start' : isCompact ? 'center' : 'flex-end'
        }
    }, navigationItems.map((item)=>/*#__PURE__*/ React.createElement("button", {
            key: item.id,
            onClick: ()=>handleMenuItemClick(item.id),
            title: isCompact ? item.label : undefined,
            "data-testid": getNavTestId(item.id),
            style: {
                width: isMobileSidebar ? '100%' : isCompact ? '100%' : 'auto',
                minWidth: isCompact ? 'auto' : '200px',
                display: 'flex',
                alignItems: 'center',
                justifyContent: isMobileSidebar ? 'flex-start' : isCompact ? 'center' : 'flex-end',
                gap: isCompact ? '0' : '0.75rem',
                padding: isCompact ? '0.75rem' : '0.75rem 1rem',
                marginBottom: '0.5rem',
                backgroundColor: 'transparent',
                color: activeMenu === item.id ? '#3b82f6' : '#6b7280',
                border: 'none',
                borderRadius: '0.5rem',
                cursor: 'pointer',
                transition: 'all 0.2s ease',
                fontSize: '0.875rem',
                fontWeight: activeMenu === item.id ? '600' : '500',
                position: 'relative',
                textAlign: 'right',
                transform: activeMenu === item.id ? 'scale(1.02)' : 'scale(1)'
            },
            onMouseEnter: (e)=>{
                if (activeMenu !== item.id) {
                    e.currentTarget.style.color = '#374151';
                    e.currentTarget.style.transform = 'scale(1.01)';
                }
            },
            onMouseLeave: (e)=>{
                if (activeMenu !== item.id) {
                    e.currentTarget.style.color = '#6b7280';
                    e.currentTarget.style.transform = 'scale(1)';
                }
            }
        }, isMobileSidebar && /*#__PURE__*/ React.createElement(React.Fragment, null, /*#__PURE__*/ React.createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.2s ease',
                ...activeMenu === item.id && {
                    transform: 'scale(1.1)'
                }
            }
        }, item.icon), /*#__PURE__*/ React.createElement("span", {
            style: {
                marginLeft: '0.75rem'
            }
        }, item.label)), !isMobileSidebar && /*#__PURE__*/ React.createElement(React.Fragment, null, !isCompact && /*#__PURE__*/ React.createElement("span", null, item.label), /*#__PURE__*/ React.createElement("div", {
            style: {
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                transition: 'all 0.2s ease',
                ...activeMenu === item.id && {
                    transform: 'scale(1.1)'
                }
            }
        }, item.icon)))));
};
export default NavigationSection;
